<template lang="pug">
div
  //- Title
  .d-flex.align-center
    v-icon.mr-3(size="18") $yzi-file-attachment-01
    .text-md.font-semibold {{ $t('files') }}
  v-divider.mt-2.mb-4.neutral500
  //- Content
  v-card.round-lg.pa-4(outlined)
    //- Top Tabs
    v-row(no-gutters)
      v-col(cols="8")
        v-tabs(color="basic700" :height="44" show-arrows active-class="font-semibold")
          v-tab.text-sm.font-medium.text-none.px-4 {{ $t('all') }}
      v-col(align="end")
        .d-flex.align-center.justify-end
          v-btn.mr-1(@click="clickSearch" icon color="neutral500")
            v-icon(size="20") $yzi-search-sm
          v-text-field.grow(v-if="showSearchField" v-model="searchText" @input="queryChanged" @blur="blurSearch" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
          v-btn.button-sm(depressed color="neutral700" dark @click="showUploadDialog = true") {{ $t('upload') }}
    v-divider
    //- Data
    .data-table
      v-data-table.mt-sm-4.pb-6(:headers="headers" :items="items" item-key="id" :items-per-page="pageSize" :page="currentPage" :loading="isFetching" hide-default-footer  :header-props="{ sortIcon: '$yzi-triangle' }" loader-height="2")
        //- actions
        template(v-slot:item.actions="{ item }")
          .d-flex.justify-end
            v-tooltip(top color="black" content-class="black")
              template(#activator="{ on, attrs }")
                v-btn.mr-1(v-bind="attrs" v-on="on" icon small @click="onDownload(item)")
                  v-icon(size=20) $yzi-download-01
              .text-sm.font-semibold.basic500--text {{ $t('download') }}
            v-menu(offset-y left rounded="lg")
              template(v-slot:activator="{ on }")
                v-btn(icon small v-on="on")
                  v-icon mdi-dots-horizontal
              v-list.py-0
                v-list-item(@click="onEditItem(item)")
                  v-list-item-title.text-sm {{ $t('edit') }}
                v-divider
                v-list-item(@click="onDeleteItem(item)")
                  v-list-item-title.text-sm.danger500--text {{ $t('delete') }}
      div.d-flex.align-center(v-if="totalCount > pageSize")
        v-spacer
        div
          yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Item list")
  .dialogs
    edit-attachment-dialog(v-if="showEditDialog" :open.sync="showEditDialog" :pid="leadPid" :file="selectedItem" @onUpdated="onChanged")
    upload-attachment-dialog(v-if="showUploadDialog" :open.sync="showUploadDialog" :pid="leadPid" @onUploaded="onChanged")
    delete-attachment-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :pid="leadPid" :file="selectedItem" @deleted="onChanged")
</template>

<script>
import { debounce } from '@/utils'
import { mapState, mapGetters, mapActions } from 'vuex'
import DeleteAttachmentDialog from '@/components/clinic/dialogs/DeleteAttachmentDialog.vue'
import EditAttachmentDialog from '@/components/clinic/dialogs/EditAttachmentDialog.vue'
import UploadAttachmentDialog from '@/components/clinic/dialogs/UploadAttachmentDialog.vue'

export default {
  components: {
    UploadAttachmentDialog, EditAttachmentDialog, DeleteAttachmentDialog
  },
  props: {
    patientId: {
      type: Number,
      required: true
    },
    leadPid: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      searchText: null,
      showSearchField: false,
      currentPage: 1,
      pageSize: 10,
      headers: [
        {
          text: 'name',
          value: 'name',
          sortable: true
        },
        {
          text: '',
          value: 'actions',
          sortable: false
        }
      ],
      selectedItem: null,
      isFetching: false,
      items: [],
      totalCount: 0,
      showUploadDialog: false,
      showDeleteDialog: false,
      showEditDialog: false
    }
  },
  mounted () {
    this.fetchAttachments()
  },
  watch: {
    currentPage() {
      this.fetchAttachments()
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany'
    }),
    params () {
      return {
        search: this.searchText,
        page: this.currentPage,
        page_size: this.pageSize
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    queryChanged: debounce(function () {
      this.currentPage = 1
      this.fetchAttachments()
    }, 750),
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    async fetchAttachments () {
      this.isFetching = true
      try {
        const { data } = await this.$axios.get(`/clinics/${this.company.slug}/consultations/${this.leadPid}/attachments`, { params: this.params })
        this.items = data.results
        this.totalCount = data.count
      // eslint-disable-next-line no-empty
      } catch (error) {
      } finally {
        this.isFetching = false
      }
    },
    onChanged () {
      this.$emit('updated')
      this.fetchAttachments()
    },
    onDownload (item) {
      window.open(item.document.file, '_blank')
    },
    onDeleteItem (item) {
      this.selectedItem = item
      this.showDeleteDialog = true
    },
    onEditItem (item) {
      this.selectedItem = item
      this.showEditDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
</style>